import { phoneToE164 } from '#/shared/lib/format'

import type { CustomerFormData } from '../model/customer-schema'

export function buildCustomerPayload(form: CustomerFormData) {
  return {
    first_name: form.firstName,
    last_name: form.lastName || null,
    email: form.email,
    secondary_email: form.email2 || null,
    billing_email: form.billingEmail || null,
    phone: phoneToE164(form.phone),
    secondary_phone: phoneToE164(form.mobile),
    company_phone: phoneToE164(form.companyPhone),
    company: form.company || null,
    note: form.note || null,
  }
}

export function normalizeEmail(value: string | undefined) {
  return (value ?? '').trim().toLowerCase()
}
